module.exports = __webpack_public_path__ + "media/images/icon_nega0_oem-2f453a82de56e49d7cfa1bab3b258272.svg";